import React from 'react';

import styled from '@emotion/styled';

import { TabsContainerContext } from './TabsContainer';
import { ThemeInterface } from '../../theme/magma';
import { ThemeContext } from '../../theme/ThemeContext';

const StyledTabPanel = styled.div<{
  isInverse?: boolean;
  theme: ThemeInterface;
}>`
  background: none;
  color: ${props =>
    props.isInverse
      ? props.theme.colors.neutral0
      : props.theme.colors.brand.navy};
  font-family: ${props => props.theme.bodyFont};
  flex: 1;
  height: 100%;
  padding: 20px;
`;

export interface TabPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * @internal
   */
  index?: number;
  isInverse?: boolean;
  /**
   * @internal
   */
  testId?: string;
}

export const TabPanel = React.forwardRef<HTMLDivElement, TabPanelProps>(
  (props, ref) => {
    const { index, isInverse, testId, children, ...other } = props;

    const theme = React.useContext(ThemeContext);

    const { activeTabIndex, instanceId } =
      React.useContext(TabsContainerContext);
    const activeTab = activeTabIndex === index;

    const panelId = `tabpanel-${instanceId}-${index}`;
    const tabId = `tab-${instanceId}-${index}`;

    return activeTab ? (
      <StyledTabPanel
        ref={ref}
        data-testid={testId}
        id={panelId}
        role="tabpanel"
        aria-labelledby={tabId}
        isInverse={isInverse}
        theme={theme}
        {...other}
      >
        {children}
      </StyledTabPanel>
    ) : null;
  }
);
